module.exports = __webpack_public_path__ + "static/Group 467-5dc4734a8cafaa0645a57ed6cf0a3fd8.png";